import { useMemo } from "react";
import { useAuthorizationService } from "../../../../../lib/auth.service";
import { useApiClient } from "../../../../../lib/http";
import { ConditionService } from "../application/condition.service";
import { ConditionApiRepository } from "../infrastructure/condition.repository";

export const useConditionService = (): ConditionService => {
  const apiClient = useApiClient();
  const authService = useAuthorizationService();

  return useMemo(() => {
    const conditionRepository = new ConditionApiRepository(apiClient, authService);
    return new ConditionService(conditionRepository);
  }, [apiClient, authService]);
};
